export default "__VITE_ASSET__BmYl3r15__"